import React from "react";
import { NewTab, PageTabAdv } from "../../../components";
import ConfirmedOrStart from "./ConfirmedOrStart/ConfirmedOrStart";
import { useModuleAccess } from "../../../hooks";

const ConfirmedOrStarts = () => {
  const ConfirmedOrStartsMenus = [
    {
      title: "Confirmed/Starts",
      page: <ConfirmedOrStart />,
      type: "main",
      id: "recruitmentconfirmedstart_confirmedstarts",
    },
  ];
  const filteredTabs = useModuleAccess({
    allTabs: ConfirmedOrStartsMenus,
    parentId: "recruitmentconfirmedstart",
  });
  return (
    <NewTab
      tabs={filteredTabs}
      color="black"
      variant="outlined"
      mode="url"
      tabId="confirmed-start"
    />
  );
};

export default ConfirmedOrStarts;
